/*
 * Copyright (c) Outright Mental. (https://outrightmental.com) All Rights Reserved.
 */

// vendor
import React from "react";
import {useDispatch, useSelector} from "react-redux";
// app
import "./GameView.scss"
import {
  doGameLoss,
  doGameNew,
  doGameQuit,
  doGameStart,
  doGameVictory, doPlayerUpdate, doTimeTick,
  selectGameStatus,
  selectPlayerName,
  STATUS_DEFEAT,
  STATUS_LOBBY,
  STATUS_PLAYING,
  STATUS_VICTORY
} from "../engine/GameEngine";
import BoardView from "./BoardView";

/**
 GameView component
 <p>
 @return {*}
 @param {*} props for this component
 */
export default function GameView(props) {
  const
    dispatch = useDispatch(),
    gameStatusSelector = selectGameStatus(),
    gameStatus = useSelector(state => gameStatusSelector(state));

  const
    playerOneNameSelector = selectPlayerName(0),
    playerOneName = useSelector(state => playerOneNameSelector(state));

  const
    tick = () => dispatch(doTimeTick()),
    newGame = () => dispatch(doGameNew()),
    startGame = () => dispatch(doGameStart()),
    winGame = () => dispatch(doGameVictory()),
    loseGame = () => dispatch(doGameLoss()),
    quitGame = () => dispatch(doGameQuit()),
    editPlayerOneName = () => dispatch(doPlayerUpdate(0, {
      name: prompt(`Enter new name for ${playerOneName}`)
    }));


  // state machine
  switch (gameStatus) {

    //
    default:
    case STATUS_LOBBY:
      return (
        <div id="game" className="lobby">
          <div className="content">
            <h1>Lobby</h1>
            <p>Ready, {playerOneName}?</p>
          </div>
          <div className="actions">
            <button onClick={editPlayerOneName}>Change Name</button>
            <button className="success" onClick={startGame}>Start</button>
          </div>
        </div>
      );

    //
    case STATUS_PLAYING:
      return (
        <div id="game" className="playing">
          <BoardView/>
          <div className="actions">
            <button onClick={tick}>Tick</button>
            <button onClick={winGame}>Win</button>
            <button onClick={loseGame}>Lose</button>
            <button onClick={quitGame}>Quit</button>
          </div>
        </div>
      );

    //
    case STATUS_VICTORY:
      return (
        <div id="game" className="victory">
          <div className="content">
            <h1>Victory!</h1>
          </div>
          <div className="actions">
            <button onClick={newGame}>New Game</button>
          </div>
        </div>
      );

    //
    case STATUS_DEFEAT:
      return (
        <div id="game" className="defeat">
          <div className="content">
            <h1>Defeat!</h1>
          </div>
          <div className="actions">
            <button onClick={newGame}>New Game</button>
          </div>
        </div>
      );

  }
};
